import React from "react";
import { PrayerTableStyled } from "./PrayerTableStyled";
import { usePrayerCalendarData } from "./hooks/usePrayerCalendarData";
import { usePrayerCalendarUI } from "./hooks/usePrayerCalendarUI";
import { PrayerCalendarProps } from "./types";

 const PrayerCalendarStyler = ({ show }: PrayerCalendarProps) => {
  const data = usePrayerCalendarData(show);
  const ui = usePrayerCalendarUI(data);

  return (
    <PrayerTableStyled
      $rgba_odd_bg={ui.rgba_odd_bg}
      $rgba_even_bg={ui.rgba_even_bg}
      $rgba_even_text={ui.rgba_even_text}
      $rgba_odd_text={ui.rgba_odd_text}
      $rgba_border_clr={ui.rgba_border_clr}
      $rgba_border_size={ui.rgba_border_size}
      $rgba_border_style={ui.rgba_border_style}
      $rgba_light_bg={ui.rgba_light_bg}
      $rgba_light_text={ui.rgba_light_text}
      className="col-span-3 w-full"
    >
      {ui?.errorState || ui?.prayerTable}
    </PrayerTableStyled>
  );
};
export default PrayerCalendarStyler;